export default __webpack_public_path__ + "static/media/usericon.014aa0f1.png";